import { generatePath } from 'react-router-dom';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response, GeneralLedgerTransaction } from '@ui/src';
import { restatementTransactionsListApi } from './service';
import ROUTES from '../../../routes';

export interface RestatementTrasnactionsListState {
  transactions?: GeneralLedgerTransaction[];
  pagination?: Pagination;
  selectedTake?: number;
  errorsList?: string;
}

const initialState: RestatementTrasnactionsListState = {
  transactions: undefined,
};

export const restatementTrasnactionsListSlice = createSlice({
  name: 'restatementTrasnactionsList',
  initialState,
  reducers: {
    setSelectedTake: (state, action: PayloadAction<number>) => {
      state.selectedTake = action.payload;
    },
    clearRestatementTrasnactionsListState: (state) => {
      state.transactions = undefined;
      state.pagination = undefined;
      state.selectedTake = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      restatementTransactionsListApi.endpoints.getRestatementTransactionsList
        .matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      restatementTransactionsListApi.endpoints.getRestatementTransactionsList
        .matchRejected,
      (state, action: any) => {
        state.transactions = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      restatementTransactionsListApi.endpoints.getRestatementTransactionsList
        .matchFulfilled,
      (state, action: PayloadAction<Response<GeneralLedgerTransaction>>) => {
        const nextTransactions = action.payload.data.edges.map((item) => ({
          ...item.node,
          deletedAt: item?.node?.deletedAt || '',
          url: generatePath(ROUTES.RESTATEMENT_TRANSACTION, {
            transactionId: item.node.id,
          }),
        }));

        state.transactions = nextTransactions;
        state.pagination = action.payload.data.pageInfo;
      },
    );
  },
});

export const { clearRestatementTrasnactionsListState, setSelectedTake } =
  restatementTrasnactionsListSlice.actions;

export default restatementTrasnactionsListSlice.reducer;
